module.exports = __webpack_public_path__ + "img/TRY_CarInsurance_macbook.fb633db2.png";